"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var H1 = function H1(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  var classes = ['shx-h1', className];
  return /*#__PURE__*/_react.default.createElement("h1", {
    className: classes.join(' ')
  }, children);
};

H1.propType = {
  children: _propTypes.default.node.isRequired
};
var _default = H1;
exports.default = _default;